angular.module('picmonicng').directive('plsManageCourses', [
  '$modal',
  'toaster',
  function ($modal, toaser) {
    return {
      restrict: 'A',
      link: function (scope, element) {
        element.bind('click', function () {
          $modal.open({
            windowClass: 'pls-how-it-works-modal',
            templateUrl: '/templates/modals/manage-courses.html',
            controller: [
              '$scope',
              'User',
              'MarketOptionsConfig',
              '$rootScope',
              'UserService',
              function ($scope, User, MarketOptionsConfig, $rootScope, UserService) {
                $scope.MarketOptionsConfig = MarketOptionsConfig;
                $scope.UserService = UserService;
                $scope.packages = User.managePackages();
                $scope.addons = { open: 1 };

                $scope.toggleArchive = function (pathway) {
                  pathway.archived = !pathway.archived;
                  User.update_pathway(
                    { pathway_id: pathway.pathway_id },
                    { is_archived: pathway.archived },
                    function () {
                      $rootScope.$broadcast('pathwayDataChanged');
                    }
                  );
                };

                $scope.addPackage = function (pathway, package) {
                  pathway.added = 1;
                  User.savePackage({ package_id: pathway.package_id }, function () {
                    $rootScope.$broadcast('pathwayDataChanged');
                  });
                  toaser.success(package + ' Added to Courses!');
                };

                $scope.removePackage = function (pathway) {
                  pathway.added = 0;
                  User.removePackage({ id: pathway.package_id, package_id: pathway.package_id }, function () {
                    $rootScope.$broadcast('pathwayDataChanged');
                  });
                };
              },
            ],
          });
        });
      },
    };
  },
]);
